import React from 'react';
import Input from '../lib/Input';

// To decouple the Input component from the Field component
class InputWrapper extends React.Component {
    render(){
        return (
            <Input
                {...this.props}
                touched={this.props.meta.touched || this.props.meta.dirty}
                error={this.props.meta.error}
                active={this.props.meta.active}
                type={this.props.input.type || this.props.type}
                value={this.props.input.value}
                onChange={this.props.input.onChange}
                onBlur={this.props.input.onBlur}
                disableWheel={true} // Disable scroll on number for all inputs
            />
        )
    }
}

export default InputWrapper
